import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-1 mb-12 lg:mb-20',
    title:
      'text-brand-bioderma mb-4 text-center text-[28px] leading-[1.2] font-medium lg:mb-6 lg:text-[32px] lg:leading-[1.2]',
    products: '[--slide-spacing:20px] max-xl:ml-3 lg:mx-auto lg:max-w-[1240px]',
    productCard: 'w-[295px]',
    arrowPrev:
      'text-brand-bioderma top-auto right-[calc(50%)] -bottom-12 left-auto !block bg-transparent max-md:-bottom-18',
    arrowNext:
      'text-brand-bioderma top-auto -right-3 -bottom-12 left-[calc(50%)] !block bg-transparent max-md:-bottom-18',
    allProductsButton:
      'bg-brand-bioderma hover:text-brand-bioderma hover:border-brand-bioderma mx-auto mt-8 max-w-fit min-w-[300px] border-1 border-transparent text-white normal-case hover:bg-transparent max-md:mt-16',
    imageWrapper:
      "relative block overflow-hidden rounded-3xl border-x-1 border-y-3 border-white/80 bg-white/15 shadow-[inset_0_6px_28px_rgba(255,255,255,0.06),inset_0_-6px_28px_rgba(0,0,0,0.04),inset_0_0_1px_rgba(0,0,0,0.05)] backdrop-blur-xl backdrop-saturate-150 before:absolute before:inset-x-0 before:top-0 before:h-[60%] before:bg-gradient-to-b before:from-white/18 before:to-transparent before:opacity-80 before:blur-[1px] before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-[60%] after:bg-gradient-to-t after:from-white/24 after:to-transparent after:opacity-70 after:blur-[1px] after:content-['']"
  }
});
